export const DETAIL_GROUPS = {
  PHONE: 1,
  EMAIL: 2,
  ADDRESS: 3,
}
